import React from "react";
import { connect } from "react-redux";
import { sha256 } from "js-sha256";
import { Switch, withRouter, Redirect } from "react-router-dom";
import IdleTimer from "react-idle-timer";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar.jsx";
import dashboardRoutes from "../../routes/dashboard.jsx";
import PrivateRoute from "../../routes/privateRoute.jsx";

import NetworkDetector from "../../components/Notifications/NetworkDetector";
import MainDashboard from "../../views/MainDashboard/MainDashboard";
import MainHeader from "../../views/MainDashboard/MainHeader";
// import { getAdminLogout } from "../../redux/actions/adminLogoutAction";
import { logoutUser } from "../../redux/actions/authActions";
import TwoFactorAuth from "./TwoFactorAuth.jsx";


class Dashboard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.state = {
      isTwoFactorVerified: false, 
      backgroundColor: "white",
      activeColor: "info",
    };
    console.log("props hai no this",props);
    console.log("props hai this ",this.props);
    console.log("this state",this.state);

    ["_onActive", "_onIdle", "handleActiveClick", "handleBgClick"].forEach(
      (v) => (this[v] = this[v].bind(this))
    );
  }

  componentDidMount() {
    if (this.props.login.isAvailable && sessionStorage.getItem("authToken")) {
      this.props.history.push({
        pathname: "/index/homepage",
      });
      sessionStorage.setItem("walletOwnerId",this.props.login.data.partnerId);
    }
  }

  handleTwoFactorSuccess = () => {
    this.setState({ isTwoFactorVerified: true });
    // Redirect to homepage after 2FA is successful
    this.props.history.push("/index/homepage");
  };

  handleActiveClick(color) {
    this.setState({ activeColor: color });
  }

  handleBgClick(color) {
    this.setState({ backgroundColor: color });
  }

  _onActive() {
    return null;
  }

  _onAction() {
    return null;
  }

  _onIdle() {
    var authToken = localStorage.getItem("authToken");

    sessionStorage.removeItem("persist:root");
    sessionStorage.removeItem("secKey");
    // this.props.getAdminLogout({
    //   authToken: authToken,
    //   authentication: {
    //     partnerId: "1"
    //   }
    // })
    this.props.logoutUser({
      authToken: authToken,
      authentication: {
        partnerId: "1",
      },
    });

    this.props.login.isAvailable = false;
    this.props.history.push("/index/login");
  }

  render() {
    const { login, dashlogin } = this.props;
    const { isTwoFactorVerified } = this.state;
    return (
      <div className="wrapper">
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          element={document}
          onActive={this._onActive}
          onIdle={this._onIdle}
          onAction={this._onAction}
          debounce={250}
          timeout={15 * 60000}
        // timeout={1 * 60000}
        />

<div className="maindashboard-panel" ref="mainPanel">
          {login.isAvailable && this.props.login.data.twoFactorGoogle=="Y" && !isTwoFactorVerified ? (
            <TwoFactorAuth 
              qrCode={this.props.login.data.googleQRbase64}  //base64 string img 
              LoginName = {this.props.login.data.LoginName}
              PID = {this.props.login.data.partnerId}
              onSubmit={this.handleTwoFactorSuccess} // Handle success
            />
          ) : (
            login.isAvailable ? (
              <>
                <MainHeader />
                <MainDashboard />
              </>
            ) : (
              <Redirect
                to={{
                  pathname: "/index/login",
                  search: "?walletOwnerId=1",
                }}
              />
            )
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  login: state.login,
});

export default connect(mapStateToProps, { logoutUser })(
  withRouter(NetworkDetector(Dashboard))
);


// import React from "react";
// import { connect } from "react-redux";
// import { sha256 } from "js-sha256";
// import { Switch, withRouter, Redirect } from "react-router-dom";
// import IdleTimer from "react-idle-timer";
// import Header from "../../components/Header/Header";
// import Sidebar from "../../components/Sidebar/Sidebar.jsx";
// import dashboardRoutes from "../../routes/dashboard.jsx";
// import PrivateRoute from "../../routes/privateRoute.jsx";

// import NetworkDetector from "../../components/Notifications/NetworkDetector";
// import MainDashboard from "../../views/MainDashboard/MainDashboard";
// import MainHeader from "../../views/MainDashboard/MainHeader";
// // import { getAdminLogout } from "../../redux/actions/adminLogoutAction";
// import { logoutUser } from "../../redux/actions/authActions";

// class Dashboard extends React.PureComponent {
//   constructor(props) {
//     super(props);
//     this.idleTimer = null;
//     this.state = {
//       backgroundColor: "white",
//       activeColor: "info",
//     };
//     console.log("props hai no this",props);
//     console.log("props hai this ",this.props);
//     console.log("this state",this.state);
//     console.log("this what i want", this.props.login.data.status);

//     ["_onActive", "_onIdle", "handleActiveClick", "handleBgClick"].forEach(
//       (v) => (this[v] = this[v].bind(this))
//     );
//   }

//   componentDidMount() {
//     if (this.props.login.isAvailable && sessionStorage.getItem("authToken")) {
//       this.props.history.push({
//         pathname: "/index/homepage",
//       });
//       sessionStorage.setItem("walletOwnerId",this.props.login.data.partnerId);
//     }
//   }

//   handleActiveClick(color) {
//     this.setState({ activeColor: color });
//   }

//   handleBgClick(color) {
//     this.setState({ backgroundColor: color });
//   }

//   _onActive() {
//     return null;
//   }

//   _onAction() {
//     return null;
//   }

//   _onIdle() {
//     var authToken = localStorage.getItem("authToken");

//     sessionStorage.removeItem("persist:root");
//     sessionStorage.removeItem("secKey");
//     // this.props.getAdminLogout({
//     //   authToken: authToken,
//     //   authentication: {
//     //     partnerId: "1"
//     //   }
//     // })
//     this.props.logoutUser({
//       authToken: authToken,
//       authentication: {
//         partnerId: "1",
//       },
//     });

//     this.props.login.isAvailable = false;
//     this.props.history.push("/index/login");
//   }

//   render() {
//     const { login, dashlogin } = this.props;

//     return (
//       <div className="wrapper">
//         <IdleTimer
//           ref={(ref) => {
//             this.idleTimer = ref;
//           }}
//           element={document}
//           onActive={this._onActive}
//           onIdle={this._onIdle}
//           onAction={this._onAction}
//           debounce={250}
//           timeout={15 * 60000}
//         // timeout={1 * 60000}
//         />

//         {/* {login.isAvailable ? (
//           <MainDashboard />
//         ) : (
//           <Redirect
//             to={{
//               pathname: "/index/login",
//               search: "?walletOwnerId=1",
//             }}
//           />
//         )} */}
//         <div className="maindashboard-panel" ref="mainPanel">
//           {login.isAvailable ? (
//             <MainHeader />
//           ) : (
//             <Redirect
//               to={{
//                 pathname: "/index/login",
//                 search: "?walletOwnerId=1",
//               }}
//             />
//           )}
//           {login.isAvailable ? (
//             <MainDashboard />
//           ) : (
//             <Redirect
//               to={{
//                 pathname: "/index/login",
//                 search: "?walletOwnerId=1",
//               }}
//             />
//           )}

//           {/* <Sidebar
//           {...this.props}
//           routes={dashboardRoutes}
//           bgColor={this.state.backgroundColor}
//           activeColor={this.state.activeColor}
//         />
//         <div className="main-panel" ref="mainPanel">
//           {login.isAvailable ? (
//             <Header {...this.props} />
//           ) : (
//             <Redirect
//               to={{
//                 pathname: "/index/login",
//                 search: "?walletOwnerId=1",
//               }}
//             />
//           )}
//           <Switch>
//             {dashboardRoutes.map((prop, key) => {
//               return (
//                 <PrivateRoute
//                   path={prop.path}
//                   component={prop.component}
//                   key={key}
//                   isAvailable={login.isAvailable}
//                 />
//               );
//             })}
//           </Switch> */}
//           {/* <Footer fluid /> */}
//         </div>
//       </div>
//     );
//   }
// }

// const mapStateToProps = (state) => ({
//   login: state.login,
// });

// export default connect(mapStateToProps, { logoutUser })(
//   withRouter(NetworkDetector(Dashboard))
// );





// import React from "react";
// import { connect } from "react-redux";
// import { sha256 } from "js-sha256";
// import { Switch, withRouter, Redirect } from "react-router-dom";
// import IdleTimer from "react-idle-timer";
// import Header from "../../components/Header/Header";
// import Sidebar from "../../components/Sidebar/Sidebar.jsx";
// import dashboardRoutes from "../../routes/dashboard.jsx";
// import PrivateRoute from "../../routes/privateRoute.jsx";

// import NetworkDetector from "../../components/Notifications/NetworkDetector";
// import MainDashboard from "../../views/MainDashboard/MainDashboard";
// import MainHeader from "../../views/MainDashboard/MainHeader";
// // import { getAdminLogout } from "../../redux/actions/adminLogoutAction";
// import { logoutUser } from "../../redux/actions/authActions";
// import TwoFactorAuth from "./TwoFactorAuth.jsx"; // Import 2FA component

// class Dashboard extends React.PureComponent {
//   constructor(props) {
//     super(props);
//     this.idleTimer = null;
//     this.state = {
//       backgroundColor: "white",
//       activeColor: "info",
//       is2FAComplete: false, // Track 2FA status
//     };
//     console.log("props hai no this", props);
//     console.log("props hai this ", this.props);
//     console.log("this state", this.state);
//     console.log("this what i want", this.props.login.data.status);

//     ["_onActive", "_onIdle", "handleActiveClick", "handleBgClick", "handle2FASuccess"].forEach(
//       (v) => (this[v] = this[v].bind(this))
//     );
//   }

//   componentDidMount() {
//     if (this.props.login.isAvailable && sessionStorage.getItem("authToken")) {
//       sessionStorage.setItem("walletOwnerId", this.props.login.data.partnerId);
//     }
//   }

//   handleActiveClick(color) {
//     this.setState({ activeColor: color });
//   }

//   handleBgClick(color) {
//     this.setState({ backgroundColor: color });
//   }

//   _onActive() {
//     return null;
//   }

//   _onAction() {
//     return null;
//   }

//   _onIdle() {
//     var authToken = localStorage.getItem("authToken");

//     sessionStorage.removeItem("persist:root");
//     sessionStorage.removeItem("secKey");

//     this.props.logoutUser({
//       authToken: authToken,
//       authentication: {
//         partnerId: "1",
//       },
//     });

//     this.props.login.isAvailable = false;
//     this.props.history.push("/index/login");
//   }

//   // Handle successful 2FA
//   handle2FASuccess() {
//     this.setState({ is2FAComplete: true });
//   }

//   render() {
//     const { login } = this.props;
//     const { is2FAComplete } = this.state;

//     // Show 2FA screen if login is successful but 2FA is not yet complete
//     if (login.isAvailable && this.props.login.data.twoFactorGoogle=="Y" && !is2FAComplete) {
//       return (
//         <TwoFactorAuth
//           qrCode={this.props.login.data.googleQRbase64}  //base64 string img 
//           onSubmit={(success) => {
//             if (success) {
//               this.handle2FASuccess();
//             } else {
//               alert("Invalid OTP, try again.");
//             }
//           }}
//           LoginName = {this.props.login.data.LoginName}
//           PID = {this.props.login.data.partnerId}
//         />
//       );
//     }

//     // Render the main dashboard if both login and 2FA are successful
//     return (
//       <div className="wrapper">
//         <IdleTimer
//           ref={(ref) => {
//             this.idleTimer = ref;
//           }}
//           element={document}
//           onActive={this._onActive}
//           onIdle={this._onIdle}
//           onAction={this._onAction}
//           debounce={250}
//           timeout={15 * 60000}
//         />

//         <div className="maindashboard-panel" ref="mainPanel">
//           {login.isAvailable ? (
//             <MainHeader />
//           ) : (
//             <Redirect
//               to={{
//                 pathname: "/index/login",
//                 search: "?walletOwnerId=1",
//               }}
//             />
//           )}
//           {login.isAvailable ? (
//             <MainDashboard />
//           ) : (
//             <Redirect
//               to={{
//                 pathname: "/index/login",
//                 search: "?walletOwnerId=1",
//               }}
//             />
//           )}
//         </div>
//       </div>
//     );
//   }
// }

// const mapStateToProps = (state) => ({
//   login: state.login,
// });

// export default connect(mapStateToProps, { logoutUser })(withRouter(NetworkDetector(Dashboard)));


        